(function (app) {
    app.provider("pointAdjustmentApi", [function () {
        this.$get = [
            "portalApiGateway", function (portalApiGateway) {
                var service = {};

                service.submitPointAdjustmentForm = function (form) {
                    return portalApiGateway.post("/MarketingDollarPointAdjustment/", form);
                };
                service.sendPointAdjustmentEmails = function (arcMarketingDollarRequestId, emailData) {
                    return portalApiGateway.post("/MarketingDollarPointAdjustment/" + arcMarketingDollarRequestId +
                        "/SendEmails/?firstName=" + emailData.firstName +
                        "&lastName=" + emailData.lastName +
                        "&sendToEmail=" + emailData.sendToEmail,
                        //marketingConsultant,
                        {
                        params: {
                                firstName: emailData.firstName,
                                lastName: emailData.lastName,
                                sendToEmail: emailData.sendToEmail
                        }
                    });
                };
                service.uploadToRequest = function (arcMarketingDollarRequestId, formData) {
                    return portalApiGateway.postFile("/MarketingDollarPointAdjustment/" + arcMarketingDollarRequestId + "/FileUpload/", formData);
                };
                service.getMarketingConsultant = function () {
                    return portalApiGateway.get("/MarketingDollarPointAdjustment/MarketingConsultant");
                }; 

                return service;
            }
        ];
    }
    ]);
})(window.app);